// extracted by mini-css-extract-plugin
export default {"container":"details_container__CtABo","content":"details_content__p7oFm"};